var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bookmark-frame",on:{"click":function($event){return _vm.toggle(_vm.jobId)}}},[_c('i',{staticClass:"vs-icon notranslate icon-scale feather icon-custom-bookmark",class:{'icon-filled': _vm.isActive}})])
}
var staticRenderFns = []

export { render, staticRenderFns }